import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/authContext";
import { useNotifications } from "../../contexts/notificationContext";
import DataService from '../../services/data.service';
import FormatUtils from "../../utils/FormatUtils";

interface FooterProps {
    transparent?: boolean
    fluid?: boolean
}

interface VersionInfoModel {
    version: string
    versionDate: string
}

const DefaultFooter: React.FC<FooterProps> = ({ transparent, fluid }) => {
    const [versionInfo, setVersionInfo] = useState<VersionInfoModel>()
    const { handleException } = useNotifications()
    const { user } = useAuth();
    const utils = new FormatUtils()

    useEffect(() => {
        getVersionInfo()
    }, [user])

    function getVersionInfo() {
        if (user)
            DataService.get<VersionInfoModel>('api/v1/VersionInfo')
                .then(response => setVersionInfo({ ...response }))
                .catch(e => { handleException(e); });
    }

    return (
        <footer className={"footer" + (transparent !== undefined ? " footer-transparent" : "")}>
            <div className={"container" + (fluid !== undefined ? "-fluid" : "")}>
                <nav className="copyright pull-right">
                    {versionInfo && (`PLM ${versionInfo.version} ${utils.formatDateTime(versionInfo.versionDate)}`)}
                </nav>
                <p className="copyright pull-left">
                    &copy; {new Date().getFullYear()}{" "}
                    <a>XBit</a> {user && '- ' + user.environment + '/' + user.database}
                </p>
            </div>
        </footer>
    );
}
export default DefaultFooter;